<div class="flex items-center success">
    <div class="ca-text-md chip-content"><ng-content></ng-content></div>
    <ca-icon icon="check-default" class="ca-icon-success ms-3"></ca-icon>
</div>
